export default __webpack_public_path__ + "static/media/sensory.d94db3b0.png";